/** PURE_IMPORTS_START  PURE_IMPORTS_END */
export function hostReportError(err) {
    setTimeout(function () { throw err; });
}
//# sourceMappingURL=hostReportError.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/ngx-export-as/node_modules/rxjs/_esm5/internal/util/hostReportError.js
// module id = ./node_modules/ngx-export-as/node_modules/rxjs/_esm5/internal/util/hostReportError.js
// module chunks = vendor